<template>
    <div class="option-box">
        <div class="group-box">
            <div class="group-title">
                设置积分抵现
            </div>
            <div class="group-data">
                <el-form ref="form" :model="formData" label-width="80px">
                    <el-form-item label="积分抵现">
                        <el-radio v-model="formData.deduct_state" label="1">开启</el-radio>
                        <el-radio v-model="formData.deduct_state" label="0">关闭</el-radio>
                    </el-form-item>
                    <el-form-item label="抵现条件">
                        大于等于 <el-input size="mini" class="num" v-model="formData.deduct_min_score" placeholder=""></el-input> 积分才能抵现
                    </el-form-item>
                    <el-form-item label="抵现比例">
                        <el-input size="mini" class="num" v-model="formData.deduct_rate" placeholder=""></el-input> 积分=1元
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "ScoreDeductOption",
        data: () => ({
            formData: {
                deduct_state: "0",
                deduct_min_score: "",
                deduct_rate: ""
            }
        }),
        mounted: function () {
            this.getOption();
        },
        methods: {
            /**
             * 获取配置
             */
            getOption: function () {
                obj.postData("score/get_deduct_option", {}, res => {
                   if(res.errcode === 0){
                       if(!obj.isEmpty(res.data.option)) {
                           this.formData = res.data.option;
                       }
                   }
                });
            },
            /**
             * 提交数据
             */
            onSubmit: function () {
                obj.postData("score/set_deduct_option", this.formData, res => {
                    if(res.errcode === 0)
                        obj.message.success("配置成功");
                    else
                        obj.message.error("配置失败");
                });
            }
        }
    }
</script>

<style scoped>
    .group-box{
        margin-top: 20px;
        margin-bottom: 50px;
    }
    .group-title::before{
        content: " ";
        display: inline-block;
        vertical-align: text-top;
        width: 4px;
        height: 15px;
        background-color: #0f9cf3;
        border-radius: 2px;
        margin-right: 6px;
    }
    .group-title{
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
    }
    .group-data{
        margin-top: 16px;
    }
    .num{
        width: 60px;
    }
</style>
